import { Component, Input } from '@angular/core';
import { INavItem } from '@bssh/comp-lib';
// Radiance
import "@radiance-design-software/menu";
import "@radiance-design-software/menu-item";
import "@radiance-design-software/button";
import { ActivatedRoute, Router } from '@angular/router';
import { forEach } from 'lodash';

interface radTabItem extends INavItem {
  selected?: boolean;
}
@Component({
  selector: 'app-tabs-page',
  templateUrl: './tabs-page-layout.component.html',
  styleUrls: ['./tabs-page-layout.component.scss']
})
export class TabsPageLayoutComponent {
  @Input() pageHeader: string = "";
  @Input() menuItems: radTabItem[] = [];
  @Input() activateFn: (component: any) => void = () => { };

  public isTabsLoaded = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngAfterViewInit() {
    this.isTabsLoaded = true;
    this.updateSelectedTabs();
    this.clearSelectedStyleForUnselectedTabs();
  }

  onActivate(component: any) {
    this.activateFn(component);
    this.updateSelectedTabs();
    this.clearSelectedStyleForUnselectedTabs();
  }

  onTabChanged($event) {
    const tab = this.menuItems.find(tab => tab.label === $event.detail.value);
    this.router.navigate(tab.route, { relativeTo: this.route });
  }

  private updateSelectedTabs() {
    forEach(this.menuItems, (menuItem) => {
      menuItem.selected = false;
      if (this.router.url.includes(menuItem.route[0] as string)) {
        menuItem.selected = true;
      }
    });
  }
  
  // These are ugly hacks to clear selected style for unselected tabs
  // because in some edgecase the tabs would remain selected style even when they are not selected
  private clearSelectedStyleForUnselectedTabs() {
    setTimeout(() => {
      var tabGroups = document.querySelectorAll('rad-tab-group');
      tabGroups.forEach(tabGroup => {
        var tabGroupDom = tabGroup.shadowRoot;
        tabGroupDom.querySelectorAll('rad-tab[selected="false"]').forEach(tab => {
          tab.shadowRoot.querySelectorAll('.rad-tab--selected')
            .forEach(el => el.classList.remove('rad-tab--selected'));
        });
      });
    }, 0);
  }
}
